<div class="modal-header">
  <h4 class="modal-title pull-left"> Confirm Delete </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  Are you sure you want to delete?
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()">
    Delete
  </button>
</div>
